module.exports = __webpack_public_path__ + "img/28.c1cbc8d2.svg";